import { registerPlugin } from "@capacitor/core";
const Mute = registerPlugin("Mute", {
    web: () => import("./web").then((m) => new m.MuteWeb()),
});
export * from "./definitions";
export { Mute };
//# sourceMappingURL=index.js.map